module.exports = __webpack_public_path__ + "img/shpn.a35f125c.png";